<template>
    <div>
        <q-score-card key="QScoreCardQuilityRxCodesUsed" ref="card" title="Used Codes" api-endpoint="rx_codes_used" drill-down-label="Agent Breakdown" drill-down-route="Drilldown_QuilityRxUsedCodes" card-style="recruiting" :agent-code="agentCode" :filters="filters" v-on:most_current="updateMostCurrent">
            Note: Reflects number of times an agent's group number was used in the Pricing Tool on the QuilityRx site, or clicked (or re-clicked) on through an email to access QuilityRx site.
        </q-score-card>
    </div>
</template>
<script>
import QScoreCard from "./QScoreCard.vue";

export default {
    name: "QScoreCardQuilityRxCodesUsed",
    props: ["agentCode", "filters"],
    data: function() { // data internal to component (not available outside)
        return {

        }
    },
    mounted: function() {},
    computed: {

    },
    methods: {
        updateMostCurrent: function(most_current) {
            this.$emit('most_current', most_current);
        }
    },
    watch: {

    },
    components: {
        QScoreCard,
    }
}

</script>
<style scoped>
</style>
